var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPerformanceIndicatorCorner = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9805 0.469887L17 0.45063C17 0.45063 9.56612 -1.85949 3.64323 3.98123C-1.2935 8.84922 0.218023 17 0.218023 17L0.247274 16.9712H16.9805L16.9805 0.469887Z",
    fill: "#00A8E1"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPerformanceIndicatorCorner, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/PerformanceIndicatorCorner.55722856.svg";
export { ForwardRef as ReactComponent };